/*
 * HelpScreenBase
 * ==========
 */
import ScreenBase from '../ui/ScreenBase'

export default class HelpBase extends ScreenBase {

    constructor(game, screens) {
        super(game);

        this.landscapeView = game.make.group();
        this.portraitView = game.make.group();

        this.view.add(this.landscapeView);
        this.view.add(this.portraitView);
    }

    addSprite(paramName, atlas, texture, orientation) {
        var sprite = super.addSprite(paramName, atlas, texture);

        if (orientation === 'p') {
            this.portraitView.add(sprite);
        } else {
            this.landscapeView.add(sprite);
        }

        return sprite;
    }

    addButton(paramName, texture, action, orientation) {
        var x = 0;
        var y = 0;
        if (this.params[paramName]) {
            x = this.params[paramName][0] * PARAMS.scaleFactor;
            y = this.params[paramName][1] * PARAMS.scaleFactor
        }

        var normal = texture + '.png';

        var down = texture + 'Rollover.png';

        var button = null;
        var that = this;

        var callback = function () {
            if ((button && button.worldAlpha === 0) || this.screens.activeScreen !== that) {
                return
            }
            action(this);
            AUDIO.playSound('buttonClick');
            ARK_game_arena_connector.fireEventToArena('event_change')
        };

        var button = PARAMS.addButton(this.game, x, y, 'helpScreens', callback, this, normal, normal, down);

        button.anchor.set(0.5);

        this.addDrag(button);
        this.view.add(button);

        this.traced.push(button);
        button.tracedName = paramName;

        this.buttons.push(button);

        if (orientation === 'p') {
            this.portraitView.add(button);
        } else {
            this.landscapeView.add(button);
        }

        return button;
    }

    initHelpButtons(omitPrev, omitNext) {
        if (!omitPrev) this.prevL = this.addButton('prevL', 'helpPrevButton', this.onPrev, 'l');
        if (!omitNext) this.nextL = this.addButton('nextL', 'helpNextButton', this.onNext, 'l');
        this.exitL = this.addButton('exitL', 'helpCloseButton', this.onExit, 'l');

        if (!omitPrev) this.prevP = this.addButton('prevP', 'helpPrevButton', this.onPrev, 'p');
        if (!omitNext) this.nextP = this.addButton('nextP', 'helpNextButton', this.onNext, 'p');
        this.exitP = this.addButton('exitP', 'helpCloseButton', this.onExit, 'p')
    }

    onPrev(that) {
        that.screens.showScreen('help' + (that.page - 1));
    }

    onNext(that) {
        that.screens.showScreen('help' + (that.page + 1));
    }

    onExit(that) {
        that.game.add.tween(that.screens.bg).to({alpha: 0.5}, 250).start();
        if (that.screens.screenBeforeHelp === 'gameStart') {
            that.screens.showScreen('gameStart');
        }
        else {
            that.screens.hideScreen();
            GS.resume();
        }
    }

    setOrientation(orientation) {
        if (orientation === 'p') {
            this.portraitView.alpha = 1;
            this.landscapeView.alpha = 1;
            // this.view.removeChild(this.landscapeView)
            // this.view.add(this.portraitView)
            this.landscapeView.x = 10000;
            this.portraitView.x = 0;
        } else {
            this.portraitView.alpha = 1;
            this.landscapeView.alpha = 1;
            // this.view.removeChild(this.portraitView)
            // this.view.add(this.landscapeView)
            this.portraitView.x = 10000;
            this.landscapeView.x = 0;
        }
    }

}
